import { render } from "./BillsInbox.vue?vue&type=template&id=20d72d6a&scoped=true"
import script from "./BillsInbox.vue?vue&type=script&lang=js"
export * from "./BillsInbox.vue?vue&type=script&lang=js"

import "./BillsInbox.vue?vue&type=style&index=0&id=20d72d6a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d72d6a"]])

export default __exports__